// extracted by mini-css-extract-plugin
export default {"contentBody":"custom_contentBody__W1mDs","slideDown":"custom_slideDown__R6-lt","slideUp":"custom_slideUp__0qDLu"};